import { RELATION_PART_OF, RELATION_OWNED_BY, RELATION_PROVIDES_API, RELATION_CONSUMES_API, ENTITY_DEFAULT_NAMESPACE, stringifyEntityRef } from '@backstage/catalog-model';
import { Link, HeaderIconLinkRow, OverflowTooltip, WarningPanel, CodeSnippet, Table, Page, Header, Progress, RoutedTabs, Content, HeaderLabel, ResponseErrorPanel, HeaderTabs, PageWithHeader, ContentHeader, CreateButton, SupportButton } from '@backstage/core-components';
import { createExternalRouteRef, useElementFilter, useApi, alertApiRef, useRouteRef, attachComponentData, configApiRef, createPlugin, createApiFactory, discoveryApiRef, identityApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { scmIntegrationsApiRef, ScmIntegrationIcon } from '@backstage/integration-react';
import { getEntityRelations, EntityRefLinks, useEntity, catalogApiRef, getEntitySourceLocation, getEntityMetadataEditUrl, useEntityKinds, useEntityListProvider, EntityKindFilter, EntityRefLink, useStarredEntities, formatEntityRefTitle, getEntityMetadataViewUrl, favoriteEntityIcon, favoriteEntityTooltip, useEntityCompoundName, EntityContext, UnregisterEntityDialog, FavoriteEntity, catalogRouteRef, EntityListProvider, EntityTypePicker, UserListPicker, EntityOwnerPicker, EntityLifecyclePicker, EntityTagPicker, rootRoute, entityRoute, AsyncEntityProvider, useEntityFromUrl, entityRouteRef } from '@backstage/plugin-catalog-react';
import { makeStyles, Typography, Grid, Chip, Card, CardHeader, IconButton, Divider, CardContent, createStyles, capitalize, Select, InputBase, MenuItem, ListItem, ListItemText, Box, ListItemIcon, Popover, MenuList, Dialog, DialogTitle, DialogActions, Button, useMediaQuery, useTheme, Drawer, Link as Link$1 } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import DocsIcon from '@material-ui/icons/Description';
import EditIcon from '@material-ui/icons/Edit';
import ExtensionIcon from '@material-ui/icons/Extension';
import React, { useCallback, useState, useEffect, useMemo, useContext } from 'react';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { capitalize as capitalize$1 } from 'lodash';
import { Alert } from '@material-ui/lab';
import { useNavigate, useParams, Navigate, matchRoutes, useRoutes, Routes, Route as Route$1 } from 'react-router';
import { makeStyles as makeStyles$1 } from '@material-ui/core/styles';
import Cancel from '@material-ui/icons/Cancel';
import MoreVert from '@material-ui/icons/MoreVert';
import { ENTITY_STATUS_CATALOG_PROCESSING_TYPE, CatalogClient } from '@backstage/catalog-client';
import { Helmet } from 'react-helmet';
import FilterListIcon from '@material-ui/icons/FilterList';
import IlloSvgUrl from '../components/EntityNotFound/Illo/illo.svg';

class CatalogClientWrapper {
  constructor(options) {
    this.client = options.client;
    this.identityApi = options.identityApi;
  }
  async getLocationById(id, options) {
    var _a;
    return await this.client.getLocationById(id, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async getEntities(request, options) {
    var _a;
    return await this.client.getEntities(request, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async getEntityByName(compoundName, options) {
    var _a;
    return await this.client.getEntityByName(compoundName, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async addLocation(request, options) {
    var _a;
    return await this.client.addLocation(request, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async getOriginLocationByEntity(entity, options) {
    var _a;
    return await this.client.getOriginLocationByEntity(entity, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async getLocationByEntity(entity, options) {
    var _a;
    return await this.client.getLocationByEntity(entity, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async removeLocationById(id, options) {
    var _a;
    return await this.client.removeLocationById(id, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async removeEntityByUid(uid, options) {
    var _a;
    return await this.client.removeEntityByUid(uid, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
  async refreshEntity(entityRef, options) {
    var _a;
    return await this.client.refreshEntity(entityRef, {
      token: (_a = options == null ? void 0 : options.token) != null ? _a : await this.identityApi.getIdToken()
    });
  }
}

const createComponentRouteRef = createExternalRouteRef({
  id: "create-component",
  optional: true
});
const viewTechDocRouteRef = createExternalRouteRef({
  id: "view-techdoc",
  optional: true,
  params: ["namespace", "kind", "name"]
});

const useStyles$7 = makeStyles((theme) => ({
  value: {
    fontWeight: "bold",
    overflow: "hidden",
    lineHeight: "24px",
    wordBreak: "break-word"
  },
  label: {
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: 0.5,
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
}));
const AboutField = ({label, value, gridSizes, children}) => {
  const classes = useStyles$7();
  const childElements = useElementFilter(children, (c) => c.getElements());
  const content = childElements.length > 0 ? childElements : /* @__PURE__ */ React.createElement(Typography, {
    variant: "body2",
    className: classes.value
  }, value || `unknown`);
  return /* @__PURE__ */ React.createElement(Grid, {
    item: true,
    ...gridSizes
  }, /* @__PURE__ */ React.createElement(Typography, {
    variant: "subtitle2",
    className: classes.label
  }, label), content);
};

const useStyles$6 = makeStyles({
  description: {
    wordBreak: "break-word"
  }
});
const AboutContent = ({entity}) => {
  var _a, _b, _c, _d, _e, _f;
  const classes = useStyles$6();
  const isSystem = entity.kind.toLocaleLowerCase("en-US") === "system";
  const isResource = entity.kind.toLocaleLowerCase("en-US") === "resource";
  const isComponent = entity.kind.toLocaleLowerCase("en-US") === "component";
  const isAPI = entity.kind.toLocaleLowerCase("en-US") === "api";
  const isTemplate = entity.kind.toLocaleLowerCase("en-US") === "template";
  const isLocation = entity.kind.toLocaleLowerCase("en-US") === "location";
  const isGroup = entity.kind.toLocaleLowerCase("en-US") === "group";
  const partOfSystemRelations = getEntityRelations(entity, RELATION_PART_OF, {
    kind: "system"
  });
  const partOfComponentRelations = getEntityRelations(entity, RELATION_PART_OF, {
    kind: "component"
  });
  const partOfDomainRelations = getEntityRelations(entity, RELATION_PART_OF, {
    kind: "domain"
  });
  const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);
  return /* @__PURE__ */ React.createElement(Grid, {
    container: true
  }, /* @__PURE__ */ React.createElement(AboutField, {
    label: "Description",
    gridSizes: {xs: 12}
  }, /* @__PURE__ */ React.createElement(Typography, {
    variant: "body2",
    paragraph: true,
    className: classes.description
  }, ((_a = entity == null ? void 0 : entity.metadata) == null ? void 0 : _a.description) || "No description")), /* @__PURE__ */ React.createElement(AboutField, {
    label: "Owner",
    value: "No Owner",
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }, ownedByRelations.length > 0 && /* @__PURE__ */ React.createElement(EntityRefLinks, {
    entityRefs: ownedByRelations,
    defaultKind: "group"
  })), (isSystem || partOfDomainRelations.length > 0) && /* @__PURE__ */ React.createElement(AboutField, {
    label: "Domain",
    value: "No Domain",
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }, partOfDomainRelations.length > 0 && /* @__PURE__ */ React.createElement(EntityRefLinks, {
    entityRefs: partOfDomainRelations,
    defaultKind: "domain"
  })), (isAPI || isComponent || isResource || partOfSystemRelations.length > 0) && /* @__PURE__ */ React.createElement(AboutField, {
    label: "System",
    value: "No System",
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }, partOfSystemRelations.length > 0 && /* @__PURE__ */ React.createElement(EntityRefLinks, {
    entityRefs: partOfSystemRelations,
    defaultKind: "system"
  })), isComponent && partOfComponentRelations.length > 0 && /* @__PURE__ */ React.createElement(AboutField, {
    label: "Parent Component",
    value: "No Parent Component",
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }, /* @__PURE__ */ React.createElement(EntityRefLinks, {
    entityRefs: partOfComponentRelations,
    defaultKind: "component"
  })), (isAPI || isComponent || isResource || isTemplate || isGroup || isLocation || typeof ((_b = entity == null ? void 0 : entity.spec) == null ? void 0 : _b.type) === "string") && /* @__PURE__ */ React.createElement(AboutField, {
    label: "Type",
    value: (_c = entity == null ? void 0 : entity.spec) == null ? void 0 : _c.type,
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }), (isAPI || isComponent || typeof ((_d = entity == null ? void 0 : entity.spec) == null ? void 0 : _d.lifecycle) === "string") && /* @__PURE__ */ React.createElement(AboutField, {
    label: "Lifecycle",
    value: (_e = entity == null ? void 0 : entity.spec) == null ? void 0 : _e.lifecycle,
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }), /* @__PURE__ */ React.createElement(AboutField, {
    label: "Tags",
    value: "No Tags",
    gridSizes: {xs: 12, sm: 6, lg: 4}
  }, (((_f = entity == null ? void 0 : entity.metadata) == null ? void 0 : _f.tags) || []).map((t) => /* @__PURE__ */ React.createElement(Chip, {
    key: t,
    size: "small",
    label: t
  }))));
};

const useStyles$5 = makeStyles({
  gridItemCard: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 10px)",
    marginBottom: "10px"
  },
  fullHeightCard: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  gridItemCardContent: {
    flex: 1
  },
  fullHeightCardContent: {
    flex: 1
  }
});
function AboutCard({variant}) {
  var _a;
  const classes = useStyles$5();
  const {entity} = useEntity();
  const scmIntegrationsApi = useApi(scmIntegrationsApiRef);
  const catalogApi = useApi(catalogApiRef);
  const alertApi = useApi(alertApiRef);
  const viewTechdocLink = useRouteRef(viewTechDocRouteRef);
  const entitySourceLocation = getEntitySourceLocation(entity, scmIntegrationsApi);
  const entityMetadataEditUrl = getEntityMetadataEditUrl(entity);
  const providesApiRelations = getEntityRelations(entity, RELATION_PROVIDES_API);
  const consumesApiRelations = getEntityRelations(entity, RELATION_CONSUMES_API);
  const hasApis = providesApiRelations.length > 0 || consumesApiRelations.length > 0;
  const viewInSource = {
    label: "View Source",
    disabled: !entitySourceLocation,
    icon: /* @__PURE__ */ React.createElement(ScmIntegrationIcon, {
      type: entitySourceLocation == null ? void 0 : entitySourceLocation.integrationType
    }),
    href: entitySourceLocation == null ? void 0 : entitySourceLocation.locationTargetUrl
  };
  const viewInTechDocs = {
    label: "View TechDocs",
    disabled: !((_a = entity.metadata.annotations) == null ? void 0 : _a["backstage.io/techdocs-ref"]) || !viewTechdocLink,
    icon: /* @__PURE__ */ React.createElement(DocsIcon, null),
    href: viewTechdocLink && viewTechdocLink({
      namespace: entity.metadata.namespace || ENTITY_DEFAULT_NAMESPACE,
      kind: entity.kind,
      name: entity.metadata.name
    })
  };
  const viewApi = {
    title: hasApis ? "" : "No APIs available",
    label: "View API",
    disabled: !hasApis,
    icon: /* @__PURE__ */ React.createElement(ExtensionIcon, null),
    href: "api"
  };
  let cardClass = "";
  if (variant === "gridItem") {
    cardClass = classes.gridItemCard;
  } else if (variant === "fullHeight") {
    cardClass = classes.fullHeightCard;
  }
  let cardContentClass = "";
  if (variant === "gridItem") {
    cardContentClass = classes.gridItemCardContent;
  } else if (variant === "fullHeight") {
    cardContentClass = classes.fullHeightCardContent;
  }
  const refreshEntity = useCallback(async () => {
    await catalogApi.refreshEntity(stringifyEntityRef(entity));
    alertApi.post({message: "Refresh scheduled", severity: "info"});
  }, [catalogApi, alertApi, entity]);
  return /* @__PURE__ */ React.createElement(Card, {
    className: cardClass
  }, /* @__PURE__ */ React.createElement(CardHeader, {
    title: "About",
    action: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, {
      "aria-label": "Refresh",
      title: "Schedule entity refresh",
      onClick: refreshEntity
    }, /* @__PURE__ */ React.createElement(CachedIcon, null)), /* @__PURE__ */ React.createElement(IconButton, {
      component: Link,
      "aria-label": "Edit",
      disabled: !entityMetadataEditUrl,
      title: "Edit Metadata",
      to: entityMetadataEditUrl != null ? entityMetadataEditUrl : "#"
    }, /* @__PURE__ */ React.createElement(EditIcon, null))),
    subheader: /* @__PURE__ */ React.createElement(HeaderIconLinkRow, {
      links: [viewInSource, viewInTechDocs, viewApi]
    })
  }), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(CardContent, {
    className: cardContentClass
  }, /* @__PURE__ */ React.createElement(AboutContent, {
    entity
  })));
}

const useStyles$4 = makeStyles((theme) => createStyles({
  root: {
    ...theme.typography.h4
  }
}));
const CatalogKindHeader = ({
  initialFilter = "component"
}) => {
  var _a;
  const classes = useStyles$4();
  const {kinds: allKinds = []} = useEntityKinds();
  const {updateFilters, queryParameters} = useEntityListProvider();
  const [selectedKind, setSelectedKind] = useState(((_a = [queryParameters.kind].flat()[0]) != null ? _a : initialFilter).toLocaleLowerCase("en-US"));
  useEffect(() => {
    updateFilters({
      kind: selectedKind ? new EntityKindFilter(selectedKind) : void 0
    });
  }, [selectedKind, updateFilters]);
  const options = [capitalize(selectedKind)].concat(allKinds).sort().reduce((acc, kind) => {
    acc[kind.toLocaleLowerCase("en-US")] = kind;
    return acc;
  }, {});
  return /* @__PURE__ */ React.createElement(Select, {
    input: /* @__PURE__ */ React.createElement(InputBase, {
      value: selectedKind
    }),
    value: selectedKind,
    onChange: (e) => setSelectedKind(e.target.value),
    classes
  }, Object.keys(options).map((kind) => /* @__PURE__ */ React.createElement(MenuItem, {
    value: kind,
    key: kind
  }, `${options[kind]}s`)));
};

const useStyles$3 = makeStyles({
  flexContainer: {
    flexWrap: "wrap"
  },
  itemText: {
    width: "100%",
    marginBottom: "1rem"
  }
});
const CatalogResultListItem = ({result}) => {
  const classes = useStyles$3();
  return /* @__PURE__ */ React.createElement(Link, {
    to: result.location
  }, /* @__PURE__ */ React.createElement(ListItem, {
    alignItems: "flex-start",
    className: classes.flexContainer
  }, /* @__PURE__ */ React.createElement(ListItemText, {
    className: classes.itemText,
    primaryTypographyProps: {variant: "h6"},
    primary: result.title,
    secondary: result.text
  }), /* @__PURE__ */ React.createElement(Box, null, result.kind && /* @__PURE__ */ React.createElement(Chip, {
    label: `Kind: ${result.kind}`,
    size: "small"
  }), result.lifecycle && /* @__PURE__ */ React.createElement(Chip, {
    label: `Lifecycle: ${result.lifecycle}`,
    size: "small"
  }))), /* @__PURE__ */ React.createElement(Divider, {
    component: "li"
  }));
};

function createNameColumn(props) {
  return {
    title: "Name",
    field: "resolved.name",
    highlight: true,
    render: ({entity}) => /* @__PURE__ */ React.createElement(EntityRefLink, {
      entityRef: entity,
      defaultKind: (props == null ? void 0 : props.defaultKind) || "Component"
    })
  };
}
function createSystemColumn() {
  return {
    title: "System",
    field: "resolved.partOfSystemRelationTitle",
    render: ({resolved}) => /* @__PURE__ */ React.createElement(EntityRefLinks, {
      entityRefs: resolved.partOfSystemRelations,
      defaultKind: "system"
    })
  };
}
function createOwnerColumn() {
  return {
    title: "Owner",
    field: "resolved.ownedByRelationsTitle",
    render: ({resolved}) => /* @__PURE__ */ React.createElement(EntityRefLinks, {
      entityRefs: resolved.ownedByRelations,
      defaultKind: "group"
    })
  };
}
function createSpecTypeColumn() {
  return {
    title: "Type",
    field: "entity.spec.type",
    hidden: true
  };
}
function createSpecLifecycleColumn() {
  return {
    title: "Lifecycle",
    field: "entity.spec.lifecycle"
  };
}
function createMetadataDescriptionColumn() {
  return {
    title: "Description",
    field: "entity.metadata.description",
    render: ({entity}) => /* @__PURE__ */ React.createElement(OverflowTooltip, {
      text: entity.metadata.description,
      placement: "bottom-start"
    }),
    width: "auto"
  };
}
function createTagsColumn() {
  return {
    title: "Tags",
    field: "entity.metadata.tags",
    cellStyle: {
      padding: "0px 16px 0px 20px"
    },
    render: ({entity}) => /* @__PURE__ */ React.createElement(React.Fragment, null, entity.metadata.tags && entity.metadata.tags.map((t) => /* @__PURE__ */ React.createElement(Chip, {
      key: t,
      label: t,
      size: "small",
      variant: "outlined",
      style: {marginBottom: "0px"}
    })))
  };
}

var columnFactories = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createNameColumn: createNameColumn,
  createSystemColumn: createSystemColumn,
  createOwnerColumn: createOwnerColumn,
  createSpecTypeColumn: createSpecTypeColumn,
  createSpecLifecycleColumn: createSpecLifecycleColumn,
  createMetadataDescriptionColumn: createMetadataDescriptionColumn,
  createTagsColumn: createTagsColumn
});

const CatalogTable = ({columns, actions}) => {
  var _a, _b, _c;
  const {isStarredEntity, toggleStarredEntity} = useStarredEntities();
  const {loading, error, entities, filters} = useEntityListProvider();
  const defaultColumns = useMemo(() => {
    var _a2;
    return [
      createNameColumn({defaultKind: (_a2 = filters.kind) == null ? void 0 : _a2.value}),
      createSystemColumn(),
      createOwnerColumn(),
      createSpecTypeColumn(),
      createSpecLifecycleColumn(),
      createMetadataDescriptionColumn(),
      createTagsColumn()
    ];
  }, [(_a = filters.kind) == null ? void 0 : _a.value]);
  const showTypeColumn = filters.type === void 0;
  const titlePreamble = capitalize$1((_c = (_b = filters.user) == null ? void 0 : _b.value) != null ? _c : "all");
  if (error) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(WarningPanel, {
      severity: "error",
      title: "Could not fetch catalog entities."
    }, /* @__PURE__ */ React.createElement(CodeSnippet, {
      language: "text",
      text: error.toString()
    })));
  }
  const defaultActions = [
    ({entity}) => {
      const url = getEntityMetadataViewUrl(entity);
      return {
        icon: () => /* @__PURE__ */ React.createElement(OpenInNew, {
          "aria-label": "View",
          fontSize: "small"
        }),
        tooltip: "View",
        disabled: !url,
        onClick: () => {
          if (!url)
            return;
          window.open(url, "_blank");
        }
      };
    },
    ({entity}) => {
      const url = getEntityMetadataEditUrl(entity);
      return {
        icon: () => /* @__PURE__ */ React.createElement(EditIcon, {
          "aria-label": "Edit",
          fontSize: "small"
        }),
        tooltip: "Edit",
        disabled: !url,
        onClick: () => {
          if (!url)
            return;
          window.open(url, "_blank");
        }
      };
    },
    ({entity}) => {
      const isStarred = isStarredEntity(entity);
      return {
        cellStyle: {paddingLeft: "1em"},
        icon: () => favoriteEntityIcon(isStarred),
        tooltip: favoriteEntityTooltip(isStarred),
        onClick: () => toggleStarredEntity(entity)
      };
    }
  ];
  const rows = entities.map((entity) => {
    const partOfSystemRelations = getEntityRelations(entity, RELATION_PART_OF, {
      kind: "system"
    });
    const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);
    return {
      entity,
      resolved: {
        name: formatEntityRefTitle(entity, {
          defaultKind: "Component"
        }),
        ownedByRelationsTitle: ownedByRelations.map((r) => formatEntityRefTitle(r, {defaultKind: "group"})).join(", "),
        ownedByRelations,
        partOfSystemRelationTitle: partOfSystemRelations.map((r) => formatEntityRefTitle(r, {
          defaultKind: "system"
        })).join(", "),
        partOfSystemRelations
      }
    };
  });
  const typeColumn = (columns || defaultColumns).find((c) => c.title === "Type");
  if (typeColumn) {
    typeColumn.hidden = !showTypeColumn;
  }
  const showPagination = rows.length > 20;
  return /* @__PURE__ */ React.createElement(Table, {
    isLoading: loading,
    columns: columns || defaultColumns,
    options: {
      paging: showPagination,
      pageSize: 20,
      actionsColumnIndex: -1,
      loadingType: "linear",
      showEmptyDataSourceMessage: !loading,
      padding: "dense",
      pageSizeOptions: [20, 50, 100]
    },
    title: `${titlePreamble} (${entities.length})`,
    data: rows,
    actions: actions || defaultActions
  });
};
CatalogTable.columns = columnFactories;

const useStyles$2 = makeStyles$1({
  button: {
    color: "white"
  }
});
const EntityContextMenu = ({
  UNSTABLE_extraContextMenuItems,
  UNSTABLE_contextMenuOptions,
  onUnregisterEntity
}) => {
  var _a;
  const [anchorEl, setAnchorEl] = useState();
  const classes = useStyles$2();
  const onOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(void 0);
  };
  const extraItems = UNSTABLE_extraContextMenuItems && [
    ...UNSTABLE_extraContextMenuItems.map((item) => /* @__PURE__ */ React.createElement(MenuItem, {
      key: item.title,
      onClick: () => {
        onClose();
        item.onClick();
      }
    }, /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(item.Icon, {
      fontSize: "small"
    })), /* @__PURE__ */ React.createElement(ListItemText, {
      primary: item.title
    }))),
    /* @__PURE__ */ React.createElement(Divider, {
      key: "the divider is here!"
    })
  ];
  const disableUnregister = (_a = UNSTABLE_contextMenuOptions == null ? void 0 : UNSTABLE_contextMenuOptions.disableUnregister) != null ? _a : false;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, {
    "aria-label": "more",
    "aria-controls": "long-menu",
    "aria-haspopup": "true",
    onClick: onOpen,
    "data-testid": "menu-button",
    className: classes.button
  }, /* @__PURE__ */ React.createElement(MoreVert, null)), /* @__PURE__ */ React.createElement(Popover, {
    open: Boolean(anchorEl),
    onClose,
    anchorEl,
    anchorOrigin: {vertical: "bottom", horizontal: "right"},
    transformOrigin: {vertical: "top", horizontal: "right"}
  }, /* @__PURE__ */ React.createElement(MenuList, null, extraItems, /* @__PURE__ */ React.createElement(MenuItem, {
    onClick: () => {
      onClose();
      onUnregisterEntity();
    },
    disabled: disableUnregister
  }, /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(Cancel, {
    fontSize: "small"
  })), /* @__PURE__ */ React.createElement(ListItemText, {
    primary: "Unregister entity"
  })))));
};

const dataKey = "plugin.catalog.entityLayoutRoute";
const Route = () => null;
attachComponentData(Route, dataKey, true);
attachComponentData(Route, "core.gatherMountPoints", true);
const EntityLayoutTitle = ({
  entity,
  title
}) => {
  return /* @__PURE__ */ React.createElement(Box, {
    display: "inline-flex",
    alignItems: "center",
    height: "1em",
    maxWidth: "100%"
  }, /* @__PURE__ */ React.createElement(Box, {
    component: "span",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }, title), entity && /* @__PURE__ */ React.createElement(FavoriteEntity, {
    entity
  }));
};
const headerProps$1 = (paramKind, paramNamespace, paramName, entity) => {
  var _a, _b, _c, _d, _e;
  const kind = (_a = paramKind != null ? paramKind : entity == null ? void 0 : entity.kind) != null ? _a : "";
  const namespace = (_b = paramNamespace != null ? paramNamespace : entity == null ? void 0 : entity.metadata.namespace) != null ? _b : "";
  const name = (_e = (_d = (_c = entity == null ? void 0 : entity.metadata.title) != null ? _c : paramName) != null ? _d : entity == null ? void 0 : entity.metadata.name) != null ? _e : "";
  return {
    headerTitle: `${name}${namespace && namespace !== ENTITY_DEFAULT_NAMESPACE ? ` in ${namespace}` : ""}`,
    headerType: (() => {
      let t = kind.toLocaleLowerCase("en-US");
      if (entity && entity.spec && "type" in entity.spec) {
        t += " \u2014 ";
        t += entity.spec.type.toLocaleLowerCase("en-US");
      }
      return t;
    })()
  };
};
const EntityLabels$1 = ({entity}) => {
  var _a;
  const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ownedByRelations.length > 0 && /* @__PURE__ */ React.createElement(HeaderLabel, {
    label: "Owner",
    value: /* @__PURE__ */ React.createElement(EntityRefLinks, {
      entityRefs: ownedByRelations,
      defaultKind: "Group",
      color: "inherit"
    })
  }), ((_a = entity.spec) == null ? void 0 : _a.lifecycle) && /* @__PURE__ */ React.createElement(HeaderLabel, {
    label: "Lifecycle",
    value: entity.spec.lifecycle
  }));
};
const EntityLayout = ({
  UNSTABLE_extraContextMenuItems,
  UNSTABLE_contextMenuOptions,
  children
}) => {
  var _a, _b, _c;
  const {kind, namespace, name} = useEntityCompoundName();
  const {entity, loading, error} = useContext(EntityContext);
  const routes = useElementFilter(children, (elements) => elements.selectByComponentData({
    key: dataKey,
    withStrictError: "Child of EntityLayout must be an EntityLayout.Route"
  }).getElements().flatMap(({props}) => {
    if (props.if && entity && !props.if(entity)) {
      return [];
    }
    return [
      {
        path: props.path,
        title: props.title,
        children: props.children,
        tabProps: props.tabProps
      }
    ];
  }), [entity]);
  const {headerTitle, headerType} = headerProps$1(kind, namespace, name, entity);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const navigate = useNavigate();
  const cleanUpAfterRemoval = async () => {
    setConfirmationDialogOpen(false);
    navigate("/");
  };
  const showRemovalDialog = () => setConfirmationDialogOpen(true);
  return /* @__PURE__ */ React.createElement(Page, {
    themeId: (_c = (_b = (_a = entity == null ? void 0 : entity.spec) == null ? void 0 : _a.type) == null ? void 0 : _b.toString()) != null ? _c : "home"
  }, /* @__PURE__ */ React.createElement(Header, {
    title: /* @__PURE__ */ React.createElement(EntityLayoutTitle, {
      title: headerTitle,
      entity
    }),
    pageTitleOverride: headerTitle,
    type: headerType
  }, entity && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EntityLabels$1, {
    entity
  }), /* @__PURE__ */ React.createElement(EntityContextMenu, {
    UNSTABLE_extraContextMenuItems,
    UNSTABLE_contextMenuOptions,
    onUnregisterEntity: showRemovalDialog
  }))), loading && /* @__PURE__ */ React.createElement(Progress, null), entity && /* @__PURE__ */ React.createElement(RoutedTabs, {
    routes
  }), error && /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(Alert, {
    severity: "error"
  }, error.toString())), !loading && !error && !entity && /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(WarningPanel, {
    title: "Entity not found"
  }, "There is no ", kind, " with the requested", " ", /* @__PURE__ */ React.createElement(Link, {
    to: "https://backstage.io/docs/features/software-catalog/references"
  }, "kind, namespace, and name"), ".")), /* @__PURE__ */ React.createElement(UnregisterEntityDialog, {
    open: confirmationDialogOpen,
    entity,
    onConfirm: cleanUpAfterRemoval,
    onClose: () => setConfirmationDialogOpen(false)
  }));
};
EntityLayout.Route = Route;

const DeleteEntityDialog = ({
  open,
  onClose,
  onConfirm,
  entity
}) => {
  const [busy, setBusy] = useState(false);
  const catalogApi = useApi(catalogApiRef);
  const alertApi = useApi(alertApiRef);
  const onDelete = async () => {
    setBusy(true);
    try {
      const uid = entity.metadata.uid;
      await catalogApi.removeEntityByUid(uid);
      onConfirm();
    } catch (err) {
      alertApi.post({message: err.message});
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ React.createElement(Dialog, {
    open,
    onClose
  }, /* @__PURE__ */ React.createElement(DialogTitle, {
    id: "responsive-dialog-title"
  }, "Are you sure you want to delete this entity?"), /* @__PURE__ */ React.createElement(DialogActions, null, /* @__PURE__ */ React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    disabled: busy,
    onClick: onDelete
  }, "Delete"), /* @__PURE__ */ React.createElement(Button, {
    onClick: onClose,
    color: "primary"
  }, "Cancel")));
};

const isOrphan = (entity) => {
  var _a, _b;
  return ((_b = (_a = entity == null ? void 0 : entity.metadata) == null ? void 0 : _a.annotations) == null ? void 0 : _b["backstage.io/orphan"]) === "true";
};
const EntityOrphanWarning = () => {
  const navigate = useNavigate();
  const catalogLink = useRouteRef(catalogRouteRef);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const {entity} = useEntity();
  const cleanUpAfterRemoval = async () => {
    setConfirmationDialogOpen(false);
    navigate(catalogLink());
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Alert, {
    severity: "warning",
    onClick: () => setConfirmationDialogOpen(true)
  }, "This entity is not referenced by any location and is therefore not receiving updates. Click here to delete."), /* @__PURE__ */ React.createElement(DeleteEntityDialog, {
    open: confirmationDialogOpen,
    entity,
    onConfirm: cleanUpAfterRemoval,
    onClose: () => setConfirmationDialogOpen(false)
  }));
};

const errorfilter = (i) => i.error && i.level === "error" && i.type === ENTITY_STATUS_CATALOG_PROCESSING_TYPE;
const hasCatalogProcessingErrors = (entity) => {
  var _a, _b;
  return ((_b = (_a = entity == null ? void 0 : entity.status) == null ? void 0 : _a.items) == null ? void 0 : _b.filter(errorfilter).length) > 0;
};
const EntityProcessingErrorsPanel = () => {
  var _a, _b;
  const {entity} = useEntity();
  const catalogProcessingErrors = ((_b = (_a = entity == null ? void 0 : entity.status) == null ? void 0 : _a.items) == null ? void 0 : _b.filter(errorfilter)) || [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, catalogProcessingErrors.map(({error}, index) => /* @__PURE__ */ React.createElement(Box, {
    key: index,
    mb: 1
  }, /* @__PURE__ */ React.createElement(ResponseErrorPanel, {
    error
  }))));
};

const getSelectedIndexOrDefault = (matchedRoute, tabs, defaultIndex = 0) => {
  if (!matchedRoute)
    return defaultIndex;
  const tabIndex = tabs.findIndex((t) => t.id === matchedRoute.route.path);
  return ~tabIndex ? tabIndex : defaultIndex;
};
const Tabbed = {
  Layout: ({children}) => {
    var _a, _b, _c;
    const routes = [];
    const tabs = [];
    const params = useParams();
    const navigate = useNavigate();
    React.Children.forEach(children, (child) => {
      if (!React.isValidElement(child)) {
        return;
      }
      if (child.type !== Tabbed.Content) {
        throw new Error("This component only accepts Content elements as direct children. Check the code of the EntityPage.");
      }
      const pathAndId = child.props.path;
      tabs.push({
        id: pathAndId,
        label: child.props.title
      });
      routes.push({
        path: pathAndId,
        element: child.props.element
      });
    });
    if (((_b = (_a = routes == null ? void 0 : routes[0]) == null ? void 0 : _a.path) != null ? _b : "") !== "")
      routes.push({
        path: "/*",
        element: /* @__PURE__ */ React.createElement(Navigate, {
          to: routes[0].path
        })
      });
    const [matchedRoute] = (_c = matchRoutes(routes, `/${params["*"]}`)) != null ? _c : [];
    const selectedIndex = getSelectedIndexOrDefault(matchedRoute, tabs);
    const currentTab = tabs[selectedIndex];
    const title = currentTab == null ? void 0 : currentTab.label;
    const onTabChange = (index) => navigate(tabs[index].id.replace(/\/\*$/, "").replace(/^\//, ""));
    const currentRouteElement = useRoutes(routes);
    if (!currentTab)
      return null;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderTabs, {
      tabs,
      selectedIndex,
      onChange: onTabChange
    }), /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(Helmet, {
      title
    }), currentRouteElement));
  },
  Content: (_props) => null
};

const EntityPageTitle = ({
  entity,
  title
}) => /* @__PURE__ */ React.createElement(Box, {
  display: "inline-flex",
  alignItems: "center",
  height: "1em"
}, title, entity && /* @__PURE__ */ React.createElement(FavoriteEntity, {
  entity
}));
const EntityLabels = ({entity}) => {
  var _a;
  const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ownedByRelations.length > 0 && /* @__PURE__ */ React.createElement(HeaderLabel, {
    label: "Owner",
    value: /* @__PURE__ */ React.createElement(EntityRefLinks, {
      entityRefs: ownedByRelations,
      defaultKind: "Group",
      color: "inherit"
    })
  }), ((_a = entity.spec) == null ? void 0 : _a.lifecycle) && /* @__PURE__ */ React.createElement(HeaderLabel, {
    label: "Lifecycle",
    value: entity.spec.lifecycle
  }));
};
const headerProps = (kind, namespace, name, entity) => {
  return {
    headerTitle: `${name}${namespace && namespace !== ENTITY_DEFAULT_NAMESPACE ? ` in ${namespace}` : ""}`,
    headerType: (() => {
      let t = kind.toLocaleLowerCase("en-US");
      if (entity && entity.spec && "type" in entity.spec) {
        t += " \u2014 ";
        t += entity.spec.type.toLocaleLowerCase("en-US");
      }
      return t;
    })()
  };
};
const EntityPageLayout = ({
  children,
  UNSTABLE_extraContextMenuItems,
  UNSTABLE_contextMenuOptions
}) => {
  var _a, _b, _c;
  const {kind, namespace, name} = useEntityCompoundName();
  const {entity, loading, error} = useContext(EntityContext);
  const {headerTitle, headerType} = headerProps(kind, namespace, name, entity);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const navigate = useNavigate();
  const cleanUpAfterRemoval = async () => {
    setConfirmationDialogOpen(false);
    navigate("/");
  };
  const showRemovalDialog = () => setConfirmationDialogOpen(true);
  return /* @__PURE__ */ React.createElement(Page, {
    themeId: (_c = (_b = (_a = entity == null ? void 0 : entity.spec) == null ? void 0 : _a.type) == null ? void 0 : _b.toString()) != null ? _c : "home"
  }, /* @__PURE__ */ React.createElement(Header, {
    title: /* @__PURE__ */ React.createElement(EntityPageTitle, {
      title: headerTitle,
      entity
    }),
    pageTitleOverride: headerTitle,
    type: headerType
  }, entity && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EntityLabels, {
    entity
  }), /* @__PURE__ */ React.createElement(EntityContextMenu, {
    UNSTABLE_extraContextMenuItems,
    UNSTABLE_contextMenuOptions,
    onUnregisterEntity: showRemovalDialog
  }))), loading && /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(Progress, null)), entity && /* @__PURE__ */ React.createElement(Tabbed.Layout, null, children), error && /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(ResponseErrorPanel, {
    error
  })), !loading && !error && !entity && /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(WarningPanel, {
    title: "Entity not found"
  }, "There is no ", kind, " with the requested", " ", /* @__PURE__ */ React.createElement(Link, {
    to: "https://backstage.io/docs/features/software-catalog/references"
  }, "kind, namespace, and name"), ".")), /* @__PURE__ */ React.createElement(UnregisterEntityDialog, {
    open: confirmationDialogOpen,
    entity,
    onConfirm: cleanUpAfterRemoval,
    onClose: () => setConfirmationDialogOpen(false)
  }));
};
EntityPageLayout.Content = Tabbed.Content;

const ENTITY_SWITCH_KEY = "core.backstage.entitySwitch";
const EntitySwitchCase = (_) => null;
attachComponentData(EntitySwitchCase, ENTITY_SWITCH_KEY, true);
const EntitySwitch = ({children}) => {
  var _a;
  const {entity} = useEntity();
  const switchCases = useElementFilter(children, (collection) => collection.selectByComponentData({
    key: ENTITY_SWITCH_KEY,
    withStrictError: "Child of EntitySwitch is not an EntitySwitch.Case"
  }).getElements().flatMap((element) => {
    const {if: condition, children: elementsChildren} = element.props;
    return [{if: condition, children: elementsChildren}];
  }));
  const matchingCase = switchCases.find((switchCase) => switchCase.if ? switchCase.if(entity) : true);
  return (_a = matchingCase == null ? void 0 : matchingCase.children) != null ? _a : null;
};
EntitySwitch.Case = EntitySwitchCase;

function strCmp(a, b) {
  return Boolean(a && (a == null ? void 0 : a.toLowerCase()) === (b == null ? void 0 : b.toLowerCase()));
}
function isKind(kind) {
  return (entity) => strCmp(entity == null ? void 0 : entity.kind, kind);
}
function isComponentType(type) {
  return (entity) => {
    if (!strCmp(entity == null ? void 0 : entity.kind, "component")) {
      return false;
    }
    const componentEntity = entity;
    return strCmp(componentEntity.spec.type, type);
  };
}
function isNamespace(namespace) {
  return (entity) => {
    var _a;
    return strCmp((_a = entity == null ? void 0 : entity.metadata) == null ? void 0 : _a.namespace, namespace);
  };
}

const FilteredEntityLayout = ({children}) => /* @__PURE__ */ React.createElement(Grid, {
  container: true,
  style: {position: "relative"}
}, children);

const FilterContainer = ({children}) => {
  const isMidSizeScreen = useMediaQuery((theme2) => theme2.breakpoints.down("md"));
  const theme = useTheme();
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  return isMidSizeScreen ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    style: {marginTop: theme.spacing(1), marginLeft: theme.spacing(1)},
    onClick: () => setFilterDrawerOpen(true),
    startIcon: /* @__PURE__ */ React.createElement(FilterListIcon, null)
  }, "Filters"), /* @__PURE__ */ React.createElement(Drawer, {
    open: filterDrawerOpen,
    onClose: () => setFilterDrawerOpen(false),
    anchor: "left",
    disableAutoFocus: true,
    keepMounted: true,
    variant: "temporary"
  }, /* @__PURE__ */ React.createElement(Box, {
    m: 2
  }, /* @__PURE__ */ React.createElement(Typography, {
    variant: "h6",
    component: "h2",
    style: {marginBottom: theme.spacing(1)}
  }, "Filters"), children))) : /* @__PURE__ */ React.createElement(Grid, {
    item: true,
    lg: 2
  }, children);
};

const EntityListContainer = ({children}) => /* @__PURE__ */ React.createElement(Grid, {
  item: true,
  xs: 12,
  lg: 10
}, children);

const CatalogPage = ({
  columns,
  actions,
  initiallySelectedFilter = "owned"
}) => {
  var _a;
  const orgName = (_a = useApi(configApiRef).getOptionalString("organization.name")) != null ? _a : "Backstage";
  const createComponentLink = useRouteRef(createComponentRouteRef);
  return /* @__PURE__ */ React.createElement(PageWithHeader, {
    title: `${orgName} Catalog`,
    themeId: "home"
  }, /* @__PURE__ */ React.createElement(EntityListProvider, null, /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(ContentHeader, {
    titleComponent: /* @__PURE__ */ React.createElement(CatalogKindHeader, null)
  }, /* @__PURE__ */ React.createElement(CreateButton, {
    title: "Create Component",
    to: createComponentLink && createComponentLink()
  }), /* @__PURE__ */ React.createElement(SupportButton, null, "All your software catalog entities")), /* @__PURE__ */ React.createElement(FilteredEntityLayout, null, /* @__PURE__ */ React.createElement(FilterContainer, null, /* @__PURE__ */ React.createElement(EntityTypePicker, null), /* @__PURE__ */ React.createElement(UserListPicker, {
    initialFilter: initiallySelectedFilter
  }), /* @__PURE__ */ React.createElement(EntityOwnerPicker, null), /* @__PURE__ */ React.createElement(EntityLifecyclePicker, null), /* @__PURE__ */ React.createElement(EntityTagPicker, null)), /* @__PURE__ */ React.createElement(EntityListContainer, null, /* @__PURE__ */ React.createElement(CatalogTable, {
    columns,
    actions
  }))))));
};

const useStyles$1 = makeStyles((theme) => ({
  illo: {
    maxWidth: "60%",
    top: 100,
    right: 20,
    position: "absolute",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "96%",
      position: "relative",
      top: "unset",
      right: "unset",
      margin: `${theme.spacing(10)}px auto ${theme.spacing(4)}px`
    }
  }
}));
const Illo = () => {
  const classes = useStyles$1();
  return /* @__PURE__ */ React.createElement("img", {
    src: IlloSvgUrl,
    className: classes.illo,
    alt: "Illustration on entity not found page"
  });
};

const useStyles = makeStyles$1((theme) => ({
  container: {
    paddingTop: theme.spacing(24),
    paddingLeft: theme.spacing(8),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2)
    }
  },
  title: {
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      fontSize: 32
    }
  },
  body: {
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.down("xs")]: {
      paddingBottom: theme.spacing(5)
    }
  }
}));
const EntityNotFound = () => {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(Grid, {
    container: true,
    spacing: 0,
    className: classes.container
  }, /* @__PURE__ */ React.createElement(Illo, null), /* @__PURE__ */ React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /* @__PURE__ */ React.createElement(Typography, {
    variant: "h2",
    className: classes.title
  }, "Entity was not found"), /* @__PURE__ */ React.createElement(Typography, {
    variant: "body1",
    className: classes.body
  }, "Want to help us build this? Check out our Getting Started documentation."), /* @__PURE__ */ React.createElement(Button, {
    variant: "contained",
    color: "primary",
    href: "https://backstage.io/docs"
  }, "DOCS")));
};

const DefaultEntityPage = () => /* @__PURE__ */ React.createElement(EntityPageLayout, null, /* @__PURE__ */ React.createElement(EntityPageLayout.Content, {
  path: "/",
  title: "Overview",
  element: /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(Typography, {
    variant: "h2"
  }, "This is the default entity page."), /* @__PURE__ */ React.createElement(Typography, {
    variant: "body1"
  }, "To override this component with your custom implementation, read docs on", " ", /* @__PURE__ */ React.createElement(Link$1, {
    target: "_blank",
    href: "https://backstage.io/docs"
  }, "backstage.io/docs")))
}));
const EntityPageSwitch = ({EntityPage}) => {
  const {entity, loading, error} = useEntity();
  if (loading)
    return /* @__PURE__ */ React.createElement(EntityPageLayout, null);
  if (error || !entity)
    return /* @__PURE__ */ React.createElement(EntityNotFound, null);
  return /* @__PURE__ */ React.createElement(EntityPage, null);
};
const OldEntityRouteRedirect = () => {
  var _a;
  const {optionalNamespaceAndName, "*": rest} = useParams();
  const [name, namespace] = optionalNamespaceAndName.split(":").reverse();
  const namespaceLower = (_a = namespace == null ? void 0 : namespace.toLocaleLowerCase("en-US")) != null ? _a : ENTITY_DEFAULT_NAMESPACE;
  const restWithSlash = rest ? `/${rest}` : "";
  return /* @__PURE__ */ React.createElement(Navigate, {
    to: `../../${namespaceLower}/component/${name}${restWithSlash}`
  });
};
const EntityLoader = (props) => /* @__PURE__ */ React.createElement(AsyncEntityProvider, {
  ...useEntityFromUrl(),
  ...props
});
const Router = ({
  EntityPage = DefaultEntityPage
}) => /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route$1, {
  path: `${rootRoute.path}`,
  element: /* @__PURE__ */ React.createElement(CatalogPage, null)
}), /* @__PURE__ */ React.createElement(Route$1, {
  path: `${entityRoute.path}`,
  element: /* @__PURE__ */ React.createElement(EntityLoader, null, /* @__PURE__ */ React.createElement(EntityPageSwitch, {
    EntityPage
  }))
}), /* @__PURE__ */ React.createElement(Route$1, {
  path: "Component/:optionalNamespaceAndName/*",
  element: /* @__PURE__ */ React.createElement(OldEntityRouteRedirect, null)
}));

const catalogPlugin = createPlugin({
  id: "catalog",
  apis: [
    createApiFactory({
      api: catalogApiRef,
      deps: {discoveryApi: discoveryApiRef, identityApi: identityApiRef},
      factory: ({discoveryApi, identityApi}) => new CatalogClientWrapper({
        client: new CatalogClient({discoveryApi}),
        identityApi
      })
    })
  ],
  routes: {
    catalogIndex: catalogRouteRef,
    catalogEntity: entityRouteRef
  },
  externalRoutes: {
    createComponent: createComponentRouteRef,
    viewTechDoc: viewTechDocRouteRef
  }
});
const CatalogIndexPage = catalogPlugin.provide(createRoutableExtension({
  component: () => import('./index-110ab602.esm.js').then((m) => m.CatalogPage),
  mountPoint: catalogRouteRef
}));
const CatalogEntityPage = catalogPlugin.provide(createRoutableExtension({
  component: () => import('./index-7b0e3438.esm.js').then((m) => m.CatalogEntityPage),
  mountPoint: entityRouteRef
}));
const EntityAboutCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-06dd9658.esm.js').then((m) => m.AboutCard)
  }
}));
const EntityLinksCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-d2181250.esm.js').then((m) => m.EntityLinksCard)
  }
}));
const EntityHasSystemsCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-55d1a69b.esm.js').then((m) => m.HasSystemsCard)
  }
}));
const EntityHasComponentsCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-e3a14e6d.esm.js').then((m) => m.HasComponentsCard)
  }
}));
const EntityHasSubcomponentsCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-ef2084a6.esm.js').then((m) => m.HasSubcomponentsCard)
  }
}));
const EntityHasResourcesCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-f2f98d41.esm.js').then((m) => m.HasResourcesCard)
  }
}));
const EntityDependsOnComponentsCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-99e3a23f.esm.js').then((m) => m.DependsOnComponentsCard)
  }
}));
const EntityDependencyOfComponentsCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-112e4b31.esm.js').then((m) => m.DependencyOfComponentsCard)
  }
}));
const EntityDependsOnResourcesCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-8f587acc.esm.js').then((m) => m.DependsOnResourcesCard)
  }
}));
const EntitySystemDiagramCard = catalogPlugin.provide(createComponentExtension({
  component: {
    lazy: () => import('./index-99bc5767.esm.js').then((m) => m.SystemDiagramCard)
  }
}));

export { AboutCard as A, EntityOrphanWarning as B, CatalogPage as C, isOrphan as D, EntityAboutCard as E, EntityProcessingErrorsPanel as F, hasCatalogProcessingErrors as G, EntityPageLayout as H, EntitySwitch as I, isKind as J, isNamespace as K, isComponentType as L, FilteredEntityLayout as M, FilterContainer as N, EntityListContainer as O, Router as R, AboutContent as a, AboutField as b, CatalogClientWrapper as c, CatalogTable as d, CatalogEntityPage as e, CatalogIndexPage as f, catalogPlugin as g, EntityDependencyOfComponentsCard as h, EntityDependsOnComponentsCard as i, EntityDependsOnResourcesCard as j, EntityHasComponentsCard as k, EntityHasResourcesCard as l, EntityHasSubcomponentsCard as m, EntityHasSystemsCard as n, EntityLinksCard as o, EntitySystemDiagramCard as p, CatalogKindHeader as q, CatalogResultListItem as r, createNameColumn as s, createSystemColumn as t, createOwnerColumn as u, createSpecTypeColumn as v, createSpecLifecycleColumn as w, createMetadataDescriptionColumn as x, createTagsColumn as y, EntityLayout as z };
//# sourceMappingURL=index-db5f0fef.esm.js.map
